import { message } from "antd";
import ClipboardJS from "clipboard";
import React, { PropsWithChildren, useEffect } from "react";

export interface CopyWrapperProps extends PropsWithChildren {
  selector: string;
}

const CopyWrapper: React.FC<CopyWrapperProps> = (props) => {
  useEffect(() => {
    setTimeout(() => {
      const copy = new ClipboardJS(props.selector);
      copy.on("success", () => {
        message.success("复制成功");
      });
    }, 100);
  }, []);

  return <>{props.children}</>;
};

export default CopyWrapper;
